var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useRef, useState } from 'react';
import { useController } from 'react-hook-form';
import { Plus, Tag, Check, Minus } from 'react-feather';
import Button from '../../../Button';
import Drawer from '../../../Drawer';
import Heading from '../../../Typography/Heading';
import Paragraph from '../../../Typography/Paragraph';
import SearchInput from '../../SearchInput';
import MultiSelectFullPill from './Pill';
import MultiSelectFullCategory from './Category';
import MultiSelectFullNoResult from './NoResult';
import classNames from 'classnames';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
var MultiSelectFull = function (_a) {
    var _b, _c;
    var name = _a.name, control = _a.control, defaultValue = _a.defaultValue, categories = _a.categories, title = _a.title, description = _a.description, max = _a.max, open = _a.open, handleClose = _a.handleClose, _d = _a.submit, submit = _d === void 0 ? false : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, noResults = _a.noResults, _f = _a.placeholder, placeholder = _f === void 0 ? 'Indiquez un ou plusieurs mots-clés' : _f, custom = _a.custom, handleCustom = _a.handleCustom, noResultsCustom = _a.noResultsCustom, addCustomText = _a.addCustomText, sortingIndicationText = _a.sortingIndicationText, sorted = _a.sorted, handleSorted = _a.handleSorted, wysiwyg = _a.wysiwyg, _g = _a.enableCategoriesSelection, enableCategoriesSelection = _g === void 0 ? false : _g;
    var field = useController({ name: name, control: control, defaultValue: defaultValue }).field;
    var categoriesSlider = useRef(null);
    var _h = useState(false), selection = _h[0], setSelection = _h[1];
    var _j = useState(false), moreCategories = _j[0], setMoreCategories = _j[1];
    var _k = useState(''), search = _k[0], setSearch = _k[1];
    var _l = useState(), highlightedCategories = _l[0], setHighlightedCategories = _l[1];
    var _m = useState(), selectedCategory = _m[0], setSelectedCategory = _m[1];
    var _o = useState(categories), displayedCategories = _o[0], setDisplayedCategories = _o[1];
    var displayMaxCategories = 10;
    var handleDrawerClose = function () {
        setSearch('');
        setSelectedCategory(null);
        handleClose && handleClose();
    };
    var handleResultAdd = function (item) {
        var defaultValue = field.value || [];
        field.onChange(__spreadArray(__spreadArray([], defaultValue, true), [item], false));
        handleSorted && handleSorted(__spreadArray(__spreadArray([], sorted, true), [__assign(__assign({}, item), { linked_id: item.id, is_custom: false })], false));
    };
    var handleResultDelete = function (item) {
        field.onChange(field.value.filter(function (el) { return el.id.toString() !== item.id.toString(); }));
        handleSorted &&
            handleSorted(sorted.filter(function (el) { return el.linked_id.toString() !== item.id.toString(); }));
    };
    var handleResultDeleteFromSorted = function (item) {
        field.onChange(field.value.filter(function (el) { return el.id.toString() !== item.linked_id.toString(); }));
        handleSorted &&
            handleSorted(sorted.filter(function (el) {
                return el.linked_id.toString() !== item.linked_id.toString();
            }));
    };
    var handleCategorySelect = function (category) {
        var defaultValue = field.value || [];
        var itemsToAdd = category.children.filter(function (item) { return !defaultValue.includes(item); });
        field.onChange(__spreadArray(__spreadArray([], defaultValue, true), itemsToAdd, true));
    };
    var handleCategoryDelete = function (category) {
        if (!field.value) {
            return;
        }
        var itemsToRemove = category.children
            .filter(function (item) {
            return field.value.some(function (el) { return el.id.toString() === item.id.toString(); });
        })
            .map(function (item) { return item.id.toString(); });
        field.onChange(field.value.filter(function (el) {
            return !itemsToRemove.includes(el.id.toString());
        }));
    };
    var categoryHasChildrenSelected = function (category) {
        if (!field.value) {
            return false;
        }
        // Vérifie si au moins un enfant de la catégorie est présent dans field.value
        return category.children.some(function (child) {
            return field.value.some(function (el) { return el.id.toString() === child.id.toString(); });
        });
    };
    var handleCategoryDisplay = function (category) {
        selectedCategory && selectedCategory.id === category.id
            ? setSelectedCategory(null)
            : setSelectedCategory(category);
    };
    var isResultSelected = function (item) {
        var _a;
        return (field.value &&
            ((_a = field.value) === null || _a === void 0 ? void 0 : _a.filter(function (el) { return el.id === item.id; }).length) > 0);
    };
    var filterCategories = function (value) {
        var searchableCategories = selectedCategory ? [selectedCategory] : categories;
        if (!value) {
            setDisplayedCategories(searchableCategories);
            return;
        }
        var result = searchableCategories.map(function (category) {
            return __assign(__assign({}, category), { children: category.children.filter(function (child) {
                    return child.title.toLowerCase().includes(value.toLowerCase());
                }) });
        });
        setDisplayedCategories(result);
    };
    var countResult = function (category) {
        return category.children.filter(function (child) {
            return child.title.toLowerCase().includes(search);
        }).length;
    };
    var isNoResult = function (categories) {
        return (categories.filter(function (category) { return category.children.length; }).length === 0);
    };
    var handleHighlightedCategories = function () {
        var base = highlightedCategories && highlightedCategories.length > 0
            ? highlightedCategories
            : categories.sort(function () { return 0.5 - Math.random(); }).slice(0, displayMaxCategories);
        if (selectedCategory && !base.includes(selectedCategory)) {
            base.push(selectedCategory);
            setTimeout(function () {
                if (categoriesSlider.current) {
                    categoriesSlider.current.scrollLeft = categoriesSlider.current.scrollWidth;
                }
            }, 100);
        }
        setHighlightedCategories(base);
    };
    var createCustomValue = function () {
        if (searchInCustom() || getAllValues().length === max)
            return;
        var defaultValue = custom || [];
        var item = {
            id: (custom === null || custom === void 0 ? void 0 : custom.length) ? custom.length + 1 : 0,
            title: search,
        };
        handleCustom(__spreadArray(__spreadArray([], defaultValue, true), [item], false));
        handleSorted && handleSorted(__spreadArray(__spreadArray([], sorted, true), [__assign(__assign({}, item), { linked_id: item.id, is_custom: true })], false));
    };
    var deleteCustomValueFromSorted = function (item) {
        if (!custom)
            return;
        handleCustom(custom.filter(function (el) { return el.id.toString() !== item.linked_id.toString(); }));
        handleSorted &&
            handleSorted(sorted.filter(function (el) {
                return el.linked_id.toString() !== item.linked_id.toString();
            }));
    };
    var searchInCustom = function () {
        if (!(custom === null || custom === void 0 ? void 0 : custom.length))
            return false;
        return custom.find(function (el) { return el.title === search; });
    };
    var isCustom = function (item) {
        if (!custom)
            return false;
        return custom.includes(item);
    };
    var getAllValues = function () {
        if (!field.value && !custom)
            return [];
        if (!field.value)
            return custom;
        if (!custom)
            return field.value;
        return __spreadArray(__spreadArray([], custom, true), field.value, true);
    };
    var getCustomValues = function () {
        if (!custom)
            return [];
        return custom;
    };
    var getPredefinedValues = function () {
        if (!field.value)
            return [];
        return field.value;
    };
    var onDragEnd = function (result) {
        if (!result.destination) {
            return;
        }
        var items = Array.from(sorted);
        var removed = items.splice(result.source.index, 1)[0];
        items.splice(result.destination.index, 0, removed);
        handleSorted && handleSorted(items);
    };
    useEffect(function () {
        setDisplayedCategories(categories);
    }, [categories]);
    useEffect(function () {
        filterCategories(search);
    }, [search, selectedCategory]);
    useEffect(function () {
        handleHighlightedCategories();
    }, [categories, selectedCategory]);
    // Define sorted values if not defined yet
    useEffect(function () {
        if (sorted && sorted.length)
            return;
        var mappedValues = __spreadArray(__spreadArray([], getPredefinedValues().map(function (item) { return (__assign(__assign({}, item), { linked_id: item.id, is_custom: false })); }), true), getCustomValues().map(function (item) { return (__assign(__assign({}, item), { linked_id: item.id, is_custom: true })); }), true);
        handleSorted && handleSorted(mappedValues);
    }, []);
    return (<>
      <Drawer handleClose={handleDrawerClose} open={open}>
        <div className="px-drawer">
          <div className="flex items-center justify-between">
            <Heading level={2} type="h6">
              {title}
            </Heading>
            {max && (<Paragraph className="text-gray-400">{"".concat((_b = getAllValues().length) !== null && _b !== void 0 ? _b : 0, " / ").concat(max)}</Paragraph>)}
          </div>
          {description && (<Paragraph size="xs" className="mt-1 md:text-sm">
              {description}
            </Paragraph>)}
          {wysiwyg && (<div className="wysiwyg mt-4" dangerouslySetInnerHTML={{ __html: wysiwyg }}/>)}
        </div>
        <div className="sticky z-1 top-0 pt-8 flex flex-col gap-4 bg-white">
          <div className="px-drawer flex items-center gap-4">
            <SearchInput placeholder={placeholder} onChange={function (value) { return setSearch(value); }} onSubmit={function (value) { return filterCategories(value); }}/>
            <div className="relative flex-shrink-0 cursor-pointer" onClick={function () { return setSelection(true); }}>
              <Tag size={24}/>
              {getAllValues().length > 0 && (<div className="flex-center absolute -bottom-1 -right-1 h-4 w-4 rounded-full border border-white bg-brand-02 text-[8px] text-white">
                  {getAllValues().length}
                </div>)}
            </div>
          </div>
          <div className="px-drawer flex gap-4 overflow-auto pb-4" ref={categoriesSlider}>
            {highlightedCategories === null || highlightedCategories === void 0 ? void 0 : highlightedCategories.map(function (category) { return (<MultiSelectFullCategory key={category.id} category={category} onClick={function () { return handleCategoryDisplay(category); }} selected={(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id) === category.id} count={countResult(category)}/>); })}
            {categories.length > displayMaxCategories && (<MultiSelectFullCategory category={{ id: 'more', slug: 'more', name: 'Plus de catégories', children: [] }} onClick={function () { return setMoreCategories(true); }} more={true}/>)}
          </div>
        </div>
        <div className="px-drawer flex flex-col gap-6 border-t border-gray-200 pt-4 pb-32">
          {isNoResult(displayedCategories) &&
            !selectedCategory &&
            handleCustom &&
            noResultsCustom &&
            addCustomText ? (<div className="flex flex-col gap-4">
              <Paragraph size="xs">{noResultsCustom}</Paragraph>
              <div className={classNames('flex items-center gap-2', searchInCustom() || getAllValues().length === max
                ? 'cursor-not-allowed'
                : 'cursor-pointer')} onClick={createCustomValue}>
                <div className={classNames('rounded-full border border-brand-01 p-1', searchInCustom() && 'bg-brand-01')}>
                  {searchInCustom() ? (<Check size={14} className="text-white"/>) : (<Plus size={14}/>)}
                </div>
                {addCustomText} "{search}"
              </div>
            </div>) : isNoResult(displayedCategories) ? (<MultiSelectFullNoResult title="Aucun résultat trouvé..." text="Et si vous reformuliez votre recherche ?"/>) : (displayedCategories.map(function (category) {
            if (category.children.length === 0)
                return null;
            return (<div key={category.id}>
                  <div className="flex justify-start items-center gap-4">
                    <Paragraph size="sm" className="font-medium">
                      {category.name}
                    </Paragraph>
                    {enableCategoriesSelection && (<>
                        <Button type="inline" side="start" className="text-brand-02 text-sm" icon={categoryHasChildrenSelected(category) ? Minus : Plus} onClick={function () {
                        return categoryHasChildrenSelected(category)
                            ? handleCategoryDelete(category)
                            : handleCategorySelect(category);
                    }}>
                          Tout{' '}
                          {categoryHasChildrenSelected(category)
                        ? 'désélectionner'
                        : 'sélectionner'}
                        </Button>
                      </>)}
                  </div>

                  <div className="mt-3 flex flex-wrap gap-2">
                    {category.children.map(function (child) { return (<MultiSelectFullPill key={child.id} item={child} onClick={function () {
                        return isResultSelected(child)
                            ? handleResultDelete(child)
                            : handleResultAdd(child);
                    }} selected={isResultSelected(child)} disabled={max ? getAllValues().length >= max && !isResultSelected(child) : false}/>); })}
                  </div>
                </div>);
        }))}
        </div>
        <div className="px-drawer absolute bottom-0 left-0 w-full bg-white py-6 shadow-sticky">
          <Button className="w-full" submit={submit} onClick={function () { return !submit && handleDrawerClose(); }} loading={loading}>
            Sauvegarder
          </Button>
        </div>
      </Drawer>

      <Drawer handleClose={function () { return setSelection(false); }} open={selection} containsDraggable={true}>
        <div className="px-drawer">
          <div className="flex items-center justify-between">
            <Heading level={2} type="h6">
              Ma sélection
            </Heading>
            {max && (<Paragraph className="text-gray-400">{"".concat((_c = getAllValues().length) !== null && _c !== void 0 ? _c : 0, " / ").concat(max)}</Paragraph>)}
          </div>
          {sortingIndicationText && (<Paragraph size="xs" className="mt-1 md:text-sm">
              {sortingIndicationText}
            </Paragraph>)}

          {getAllValues().length > 0 ? (<div className="mt-8 flex flex-wrap gap-2">
              {sorted && sorted.length > 0 ? (<DragDropContext onDragEnd={onDragEnd}>
                  <Droppable droppableId={"droppable-".concat(field.name)}>
                    {function (provided) { return (<div {...provided.droppableProps} ref={provided.innerRef}>
                        {sorted.map(function (item, index) { return (<Draggable key={index} draggableId={"".concat(index)} index={index}>
                            {function (provided, snapshot) { return (<div ref={provided.innerRef} snapshot={snapshot} {...provided.draggableProps} {...provided.dragHandleProps} className="w-fit">
                                <div className="py-1">
                                  <MultiSelectFullPill key={index} item={item} sortable={true} onClick={function () {
                                return item.is_custom
                                    ? deleteCustomValueFromSorted(item)
                                    : handleResultDeleteFromSorted(item);
                            }} selected={true} disabled={false}/>
                                </div>
                              </div>); }}
                          </Draggable>); })}

                        {provided.placeholder}
                      </div>); }}
                  </Droppable>
                </DragDropContext>) : (getAllValues().map(function (item) { return (<MultiSelectFullPill key={item.id} item={item} onClick={function () { return handleResultDelete(item); }} selected={true} disabled={false}/>); }))}
            </div>) : (<MultiSelectFullNoResult title={noResults} text="Commencez à en ajouter en utilisant la barre de recherche."/>)}
        </div>
      </Drawer>

      <Drawer handleClose={function () { return setMoreCategories(false); }} open={moreCategories}>
        <div className="px-drawer">
          <div className="flex items-center justify-between">
            <Heading level={2} type="h6">
              Plus de catégories
            </Heading>
          </div>
          <div className="mt-8 flex flex-wrap gap-2">
            {categories.map(function (category) { return (<MultiSelectFullCategory key={category.id} category={category} onClick={function () { return handleCategoryDisplay(category); }} selected={(selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id) === category.id} count={countResult(category)}/>); })}
          </div>
        </div>
      </Drawer>
    </>);
};
export default MultiSelectFull;
